module.exports = __webpack_public_path__ + "fbf5c25f245eaee5a28e64724ddcc618.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fam/primecap_odyssey_funds.png
// module id = 1511
// module chunks = 0